nativeIsFinite